import { useQuery } from '@fv/client-core'
import {
  isValidNmfcLength,
  type NmfcArticleRequest,
  type NmfcSearchRequest,
} from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

import type { NmfcArticleResponse, NmfcSearchResponse } from './types'

const nmfcQueryKeys = {
  all: ['nmfc'],
  description: (dto: NmfcSearchRequest) => [
    ...nmfcQueryKeys.all,
    'desc',
    dto.description,
  ],
  article: (dto: NmfcArticleRequest) => [
    ...nmfcQueryKeys.all,
    'article',
    dto.code,
  ],
}

export const useNmfcDescriptionSearch = (dto: NmfcSearchRequest) => {
  return useQuery(
    nmfcQueryKeys.description(dto),
    () => shipperFetch<NmfcSearchResponse>(`/nmfc/search`, { query: dto }),
    {
      enabled: !!dto.description,
      staleTime: Infinity,
    },
  )
}

export const useNmfcArticleSearch = (
  dto: NmfcArticleRequest,
  enabled = true,
) => {
  return useQuery(
    nmfcQueryKeys.article(dto),
    () => shipperFetch<NmfcArticleResponse>(`/nmfc/article/${dto.code}`),
    {
      enabled: !!dto.code && enabled && isValidNmfcLength(dto.code),
      staleTime: Infinity,
      retry(_failureCount, error: { status?: number }) {
        return error.status !== 404
      },
    },
  )
}
